<template>
  <vx-card v-show="isCardActiveLocal" :style="{ 'background-color': question && question.quizDetails.isGraded ? 'rgba(255, 204, 0, 0.3)' : 'none', 'margin-bottom': '1rem' }">
    <div class="vx-row">
      <div class="vx-col w-full">
        <h5 class="mb-2">{{ answer.questionNumber }}. {{ questionTitle }}</h5>
        <p class="mb-2">{{ questionText }}</p>
        <div v-if="answer.imageUrl" class="vx-row mb-3">
          <div class="vx-col w-full">
            <img :src="answer.imageUrl" height="200px" alt="Question Image">
          </div>
        </div>
        <div class="vx-row" style="margin:0px">
          <vx-card v-if="answer.pinnedDocument" title="Pinned Document" class="w-full mb-3">
            <div class="vx-row">
              <vs-button color="success" class="ml-2" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(answer.pinnedDocument)"></vs-button>
              <span class="ml-2" style="font-weight: 700; align-self:center">{{fileName(answer.pinnedDocument)}}</span>
            </div>
          </vx-card>
        </div>
        <vx-card title="Answer/s" class="w-full mb-2">
          <div class="vx-row" v-for="(file, fileIndex) in checkforArray(answer.uploadedFile)" :key="fileIndex">
            <vs-button color="success" class="ml-2 mb-2" type="filled" icon-pack="feather" icon="icon-download" @click.stop="downloadFile(file)"></vs-button>
            <span class="ml-2" style="font-weight: 700; align-self:center">{{fileName(file)}}</span>
          </div>
        </vx-card>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :answer="answer" :predefinedComments="predefinedComments" />
  </vx-card>
</template>

<script>
  import commentView from './QuizCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      answer: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        commentView: true,
        questionText: "",
        questionTitle: ""
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setOptionColor(option, answer) {
        if(option.isCorrectAnswer){
          return 'green';
        }
        else if(answer.inputAnswer == option.optionNumber.toString()){
          return 'red';
        }
        else{
          return this.$store.state.theme == 'dark' ? '#c5c5c5' : 'black';
        }
      },
      setOptionFont(optionIndex, option, answer) {
        if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer == option.optionNumber.toString())
          return 700;
        else if((optionIndex + 1) == answer.inputAnswer && answer.inputAnswer != option.optionNumber.toString())
          return 700;
        else
          return 400;
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      checkforArray(file){
        var self = this;
        var uploadedFile = []
        if(file.includes(",")){
          uploadedFile = file.split(",");
        }
        else{
          uploadedFile.push(file);
        }
        return uploadedFile
      },
      fileName(file){
        var self = this;
        if(file){
          var size = file.length;
          var firstIndex = file.split("_")[0].length +1;
          var fileName = file.substring(firstIndex,size);
          return fileName
        }
        else{
          return file
        }
      },
      downloadFile(file){
        var self = this;
        window.open(file,"_blank");
      },
    },
    mounted() {
      if(this.answer){
        this.questionText = this.strip(this.answer.questionText);
        this.questionTitle = this.strip(this.answer.questionTitle);
      }
    }
  }

</script>

<style lang="scss">

</style>
